<template>
  <div class="search_query">
    <!-- 条件搜索 -->
    <div class="search_data">
      <div class="letter">
        <ul class="ul clearfix">
          <li
            @click="querySearch(item,index)"
            :class="{activeClass:active == item && isChange == index}"
            v-for="(item,index) of alphabeticQuery"
            :key="index"
          >{{item}}</li>
        </ul>
      </div>
      <div class="item_keyword">
        <el-input v-model="inputValue" placeholder="Please Enter Keywords"></el-input>
      </div>
      <div class="item_submit" @click="searchData">Search</div>
      <div class="item_select" v-if="isSelect">
        <el-select
          clearable
          v-model="value"
          placeholder="Please choose"
          @change="handleChange"
          @clear="clearData"
          filterable
          v-el-select-loadmore="loadmore"
          remote
          :remote-method="remoteMethod"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.ENName"
            :value="item.id"
            :disabled="item.disabled"
          ></el-option>
        </el-select>
      </div>
      <div v-if="isAddNew" class="add_new" @click="addNew">
        <span class="el-icon-circle-plus add_new_icon">&nbsp;Add New</span>
      </div>
    </div>
  </div>
</template>

<script>
//字母ABCD...
import { alphabeticQuery } from "@/conf/Backstage.js";
import { findCompanyByName } from "@/common/js/http/version3Api.js";

export default {
  name: "SearchQuery",
  props: {
    isAddNew: {
      type: Boolean,
      default: true,
    },
    isSelect: {
      type: Boolean,
      default: true,
    },
    isChange: {
      type: Number,
      default: -1,
    },
    active: {
      type: String,
      default: "",
    },
  },
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector(
          ".el-select-dropdown .el-select-dropdown__wrap"
        );
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      },
    },
  },
  data() {
    return {
      isAdd: false,
      alphabeticQuery,
      inputValue: "",
      query: {
        letterVal: "",
        inpVal: "",
      },
      options: [],
      brandArray: [],
      value: "",
      formData: {
        pageIndex: 1,
        pageSize: 20,
      },
    };
  },
  mounted() {
    if (this.$route.name == "NewsInformation") {
      this.inputValue = sessionStorage.getItem("inpVal");
    } else {
      this.inputValue = "";
    }
    this.getCompanyName(this.formData);
  },
  methods: {
    remoteMethod(companyName) {
      //console.log(companyName, 'oiuytewertyui')
      findCompanyByName(companyName).then((res) => {
        this.brandsArray = res.result;
        this.options = this.brandsArray;
      });
    },
    loadmore() {
      this.formData.pageIndex++;
      this.getCompanyName(this.formData);
    },
    //选择企业id
    handleChange(val) {
      this.options.filter((item) => {
        if (item.id === val) {
          this.value = item.value;
        }
      });
      findCompanyByName(this.value).then((res) => {
        this.brandArray = res.result;
        this.options = this.brandArray;
      });
      this.$emit("handleChange", val);
    },
    //获取企业名称
    getCompanyName(formData) {
      let num = formData.pageIndex * formData.pageSize;
      findCompanyByName("").then((res) => {
        this.brandArray = res.result;
        this.options = this.brandArray.filter((item, index) => {
          return index < num;
        });
      });
    },
    querySearch(val, index) {
      this.query.letterVal = val;

      this.$emit("letterVal", this.query, index);
    },
    searchData() {
      this.query.inpVal = this.inputValue;
      // this.inputValue = "";
      this.$emit("searchData", this.query);
    },
    // 添加 新角色
    addNew() {
      this.$emit("addNew", true);
    },
    //清除数据
    clearData() {
      this.$emit("clearData");
    },
  },
  watch: {
    options: {
      handler(newValue) {
        newValue.filter((item) => {
          if (Number(sessionStorage.getItem("companyId")) == Number(item.id)) {
            this.value = item.ENName;
            console.log(this.value, "99");
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.ul li {
  cursor: pointer;
  user-select: none;
  float: left;
  padding: 10px 7px;
  margin-bottom: 10px;
  background: #f7f8fa;
}

.activeClass {
  color: #fff;
  background: #0078ff !important;
}

.search_data > div {
  display: inline-block;
  margin-right: 15px;
  vertical-align: top;
}

.search_data >>> .el-input__inner,
.search_data >>> .el-input__icon {
  height: 32px;
  line-height: 32px;
}

.add_new {
  /*float: right;*/
  margin-left: 100px;
}

.search_data .item_submit {
  user-select: none;
  cursor: pointer;
  width: 74px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  font-size: 14px;
  color: #0078ff;
  border-radius: 2px;
  border: 1px solid #0078ff;
}

.add_new span {
  cursor: pointer;
  user-select: none;
  width: 90px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: rgba(0, 0, 0, 0);
  border: 1px solid #0078ff;
  font-size: 14px;
  color: #0078ff;
  border-radius: 2px;
}

@media screen and (max-width: 1200px) {
  .letter {
    display: block !important;
    margin-bottom: 15px;
  }
}
</style>